import React, { useEffect, useState, useCallback, use } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { UAParser } from 'ua-parser-js';
import './App.css';
import TableLayout from './Tables/TableLayout';
import HeaderComp from './Components/HeaderComp';
import FooterComp from './Components/FooterComp';
import Dashboard from './Components/Dashboard';
import { handleAuthCallback, redirectToLogin, logout } from "./auth/AuthService";
import { StyledDiv } from './App.style';
import 'leaflet/dist/leaflet.css';
import { Backdrop, CircularProgress, Box, Typography } from '@mui/material';
// import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Pagenotfound from '../src/images/404_undraw.svg'
import { getUserRole } from '../src/helper/IraHelper';
import { SnackbarProvider } from "./common/config/Snackbar";
import { formatDateTime } from "./common/CommonSnippet";
import Config from './common/config/config';

function App() {
  const [user, setUser] = useState(null);
  const [tokenUrl, setTokenUrl] = useState('/dashboard');
  const [userInfo, setUserInfo] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loader, setLoader] = useState(true);
  const [ldapUser, setLdapuser] = useState(null);
  let inactivityTimer;

  const resetTimer = () => {
    if (inactivityTimer) clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      handleLogout()
    }, 20 * 60 * 1000); // 20 minutes
  };

  const handleLogout = async () => {
    const logoutTime = formatDateTime(new Date());
    const logoutData = { "CorpName": JSON.parse(sessionStorage.getItem('user'))?.idTokenClaims?.UserID, "Logout": logoutTime };

    try {
      await fetch(`${Config.API_URL}/save_sign_out`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(logoutData),
      });
    } catch (error) {
      console.error("Error sending logout data:", error);
    }
    finally {
      sessionStorage.clear()
      logout();
    }
  };

  const activityListener = () => {
    resetTimer();
  };
  const getUserInfo = useCallback(async () => {
    const userDetails = {};
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      userDetails.ipAddress = data.ip;
    } catch (error) {
      console.error('Error fetching IP address:', error);
    }
    const parser = new UAParser();
    const result = parser.getResult();
    userDetails.BrowserName = `${result.browser.name}`;
    userDetails.loginTime = formatDateTime(new Date());

    setUserInfo(userDetails);
    return userDetails;
  }, []);

  const getUsersRole = useCallback(async (user, userInfo) => {

    const payload = {
      "CorpName": user?.UserID || "guest",
      "FirstName": user?.FirstName || "Guest",
      "LastName": user?.LastName || "User",
      "Email": user?.EmailID || "guestuser@tranetechnologies.com",
      "IsTraneEmployee": user?.EmailID.toLowerCase().includes('trane') ? 1 : 0,
      "BrowserName": userInfo?.BrowserName || "Chrome",
      "UserIpAddress": userInfo?.ipAddress || "007.22.22.222",
      "LoginTime": userInfo?.loginTime || "2025-55-55 55:55:55"
    };
    // For Dev-------------
    // const payload = {
    //   "CorpName": user?.UserID || "u118117",
    //   "FirstName": user?.FirstName || "Deepak",
    //   "LastName": user?.LastName || "N",
    //   "Email": user?.EmailID || "deepak.n@contractor.tranetechnologies.com",
    //   "IsTraneEmployee": user?.EmailID.toLowerCase().includes('trane') ? 1 : 0,
    //   "BrowserName": userInfo?.BrowserName || "Chrome",
    //   "UserIpAddress": userInfo?.ipAddress || "007.22.22.222",
    //   "LoginTime": userInfo?.loginTime || "2025-55-55 55:55:55"
    // };

    try {
      const getUserDetails = await getUserRole(payload);

      setUserRole(getUserDetails?.Role);
      sessionStorage.setItem('userRole', getUserDetails?.Role);
      setLoader(false);
      return { getUserDetails };
    } catch (error) {
      console.error('Error fetching data for tables:', error);
      throw error;
    }
  }, []);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user")?.idTokenClaims;
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      setTokenUrl(storedToken)
    }

    if (storedUser) {
      setUser(JSON.parse(storedUser));
      // setUser(storedUser); // for dev
    } else {
      if (!storedToken) {
        handleAuthCallback().then((claims) => {
          if (claims) setUser(claims);
        });
      }
    }
    getUserInfo();
    if(userRole || sessionStorage.getItem('userRole')){
      setLoader(false);
    }
  }, [getUserInfo]);

  useEffect(() => {
    if (user && userInfo) {
      if (!userRole || sessionStorage.getItem('userRole') == 'undefined' || sessionStorage.getItem('userRole') == null || sessionStorage.getItem('userRole') == undefined) {
        getUsersRole(user, userInfo);
        setUserRole(sessionStorage.getItem('userRole'));
      }
    }
  }, [user, userInfo, getUsersRole]);
  useEffect(() => {
    const handleUnload = (e) => {
      const userData = JSON.parse(sessionStorage.getItem("user"));
      if (!userData) return;
   
      const payload = {
        CorpName: user?.UserID || userData?.idTokenClaims?.UserID,
        Logout: formatDateTime(new Date()),
      };

      if (!window.performance.getEntriesByType("navigation")[0].type.includes("reload") && document.visibilityState==='hidden' ) {
        // navigator.sendBeacon(`${Config.API_URL}/save_sign_out`, JSON.stringify(payload));
        fetch(`${Config.API_URL}/save_sign_out`, {
                  method: "POST",
                  body: JSON.stringify(payload),
                  headers: {
                    "Content-Type": "application/json",
                  },
                  keepalive: true,
                })
                .catch(error => {
                  console.error('There was a problem with the fetch operation:', error);
                });
        // e.preventDefault();
        // e.returnValue = "";
      } else {
        console.log('yes reloaded / routes');
      }
    };
  
    window.addEventListener("beforeunload", handleUnload);
  
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);
  useEffect(() => {
    window.addEventListener("mousemove", activityListener);
    window.addEventListener("keydown", activityListener);
    window.addEventListener("click", activityListener);
    window.addEventListener("scroll", activityListener);

    resetTimer();

    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener("mousemove", activityListener);
      window.removeEventListener("keydown", activityListener);
      window.removeEventListener("click", activityListener);
      window.removeEventListener("scroll", activityListener);
    };
  }, []);
  if (loader) {
    return (
      <div className='loader ppde2'>
        <Backdrop
          sx={{ color: '#fff', zIndex: 100001 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    );
  }

  return (
    <Router>
      <SnackbarProvider>
        <div className="App">
          <HeaderComp user={user} userToken={tokenUrl} onHandleLogout={handleLogout} />
          <StyledDiv>
            <Routes>
              <Route path="/" element={<TableLayout usedData={user} />} />
              {(sessionStorage.getItem('userRole') === "Admin" || userRole === "Admin") && (<Route path="/Dashboard/" element={<Dashboard />} />)}
              <Route path="*" element={
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  height="100vh"
                >
                  <img src={Pagenotfound} style={{ width: "40%" }} />
                  <Typography variant="h4" style={{ marginTop: 16 }}>
                    Page Not Found
                  </Typography>
                  <Typography variant="body1" style={{ marginTop: 8 }}>
                    The page you are looking for does not exist.
                  </Typography>
                </Box>

              } />
            </Routes>
          </StyledDiv>
          <FooterComp />
        </div>
      </SnackbarProvider>
    </Router>
  );
}

export default App;
